var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleseparator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65601",
    "data-name": "Grupo 65601",
    transform: "translate(-736 -640)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65600",
    "data-name": "Grupo 65600"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4255",
    "data-name": "Elipse 4255",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(736 640)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4254",
    "data-name": "Elipse 4254",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(743 647)",
    fill: "#38d2d9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "angle-small-down",
    d: "M14.273,17.972a2.669,2.669,0,0,1-1.893-.783L5.293,10.1,7.186,8.207l7.087,7.087,7.087-7.087L23.254,10.1l-7.087,7.087a2.669,2.669,0,0,1-1.893.785Z",
    transform: "translate(761.727 667.91)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleseparator);
export default __webpack_public_path__ + "static/media/circleseparator.890674ded5e044a327291f61c183e395.svg";
export { ForwardRef as ReactComponent };